import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";

const DeleteDialog = (props, ref) => {
  const classes = useStyles();

  const { onSubmit, type } = props;
  const [open, setOpen] = React.useState(false);

  const { t } = useTranslation();

  React.useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setOpen(false);
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>
          {type === "party"
            ? t("parties.deleteTitle")
            : type === "media"
            ? t("media.deleteTitle")
            : type === "template"
            ? t("templates.deleteTitle")
            : type === "banner"
            ? "Banner löschen"
            : t("profiles.deleteTitle")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {type === "party"
              ? t("parties.delete")
              : type === "media"
              ? t("media.delete")
              : type === "template"
              ? t("templates.delete")
              : type === "banner"
              ? "Möchtest du diesen Banner wirklich löschen?"
              : t("profiles.delete")}
          </DialogContentText>
        </DialogContent>
        <div className={classes.spacer} />
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            {t("general.cancel")}
          </Button>
          <Button type="submit" color="primary" variant="contained">
            {t("general.delete")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const useStyles = makeStyles((theme) => ({
  spacer: {
    height: theme.spacing(2),
  },
}));

export default React.forwardRef(DeleteDialog);
